var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('l-nav-drawer',{attrs:{"clipped":_vm.clipped,"items":_vm.navDrawerItems}}),_c('not-auth-toolbar',{attrs:{"can-go-back":"","show-login":""}},[_c('v-toolbar-title',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v("通知中心")])])],1),_c('v-content',[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }